import { __assign, __awaiter, __generator, __makeTemplateObject } from "tslib";
/* eslint-disable react-hooks/exhaustive-deps */

/* eslint-disable @typescript-eslint/no-explicit-any */

/** @jsx jsx */

import { useState, useEffect } from 'react';
import { css } from '@emotion/react';
import base64js from 'base64-js';
import { jsx } from '@emotion/react';
import { Button, Text, Tooltip, View, InputText, Loader, Tabs, Card, useTheme, Texts, Toggle } from '@ion-ui/core';
import { SimulatorCards } from './SimulatorCheckCard';
import { ContactView } from './Contact';
import SwipeableViews from 'react-swipeable-views';
import { Products } from './utils/models';
import { LeadView } from './LeadView';
var closeSVG = jsx("svg", {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}, jsx("title", null, "Close"), jsx("g", {
  id: 'close'
}, jsx("path", {
  id: 'Path 2',
  d: 'M17.6568 17.6569L6.34313 6.34315',
  stroke: '#021215',
  strokeLinecap: 'square'
}), jsx("path", {
  id: 'Path 2_2',
  d: 'M17.6569 6.34315L6.34317 17.6569',
  stroke: '#021215',
  strokeLinecap: 'square'
})));
var infoSVG = jsx("svg", {
  width: '14',
  height: '14',
  viewBox: '0 0 14 14',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}, jsx("path", {
  d: '\n      M7 0.999999C3.68629 0.999999 1 3.68629 1 \n      7C1 10.3137 3.68629 13 7 13C10.3137 13 13 10.3137 13 7C13 3.68629 10.3137 1 7 0.999999Z',
  stroke: '#1F1FFF',
  strokeWidth: '1.5',
  strokeLinecap: 'round',
  strokeLinejoin: 'round'
}), jsx("path", {
  d: 'M7 9.66699L7 7.00033',
  stroke: '#1F1FFF',
  strokeWidth: '1.5',
  strokeLinecap: 'round',
  strokeLinejoin: 'round'
}), jsx("path", {
  d: 'M7 4.33301L6.99333 4.33301',
  stroke: '#1F1FFF',
  strokeWidth: '1.5',
  strokeLinecap: 'round',
  strokeLinejoin: 'round'
}));
var dropDown = jsx("svg", {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}, jsx("title", null, "DropDown"), jsx("g", {
  id: 'chevron-down'
}, jsx("path", {
  id: 'Path 3',
  d: 'M6 10L12 16L18 10',
  stroke: '#021215',
  strokeLinecap: 'square'
})));

var Wrapper = function Wrapper(_a) {
  var children = _a.children,
      isMultisimulator = _a.isMultisimulator,
      heroLayout = _a.heroLayout,
      cardId = _a.cardId;

  if (!isMultisimulator && heroLayout) {
    return jsx(View, {
      css: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["border-radius: 1rem;\n      width: 100%;\n      box-sizing: border-box;\n      box-shadow: 0 0 0.25rem rgb(2 18 21 / 20%);\n      padding: 1.344rem 1.344rem 0 1.344rem;\n      max-width: 25.125rem;\n      background:white;\n      overflow:scroll;\n      height: 35.625rem;"], ["border-radius: 1rem;\n      width: 100%;\n      box-sizing: border-box;\n      box-shadow: 0 0 0.25rem rgb(2 18 21 / 20%);\n      padding: 1.344rem 1.344rem 0 1.344rem;\n      max-width: 25.125rem;\n      background:white;\n      overflow:scroll;\n      height: 35.625rem;"])))
    }, children);
  }

  return jsx(Card, {
    id: cardId,
    bgColor: isMultisimulator ? 'transparent' : 'white',
    variant: 'simulator',
    shadow: isMultisimulator ? false : true
  }, jsx(View, {
    style: {
      overflow: 'scroll'
    }
  }, children));
};

var Simulator = function Simulator(_a) {
  var variant = _a.variant,
      productName = _a.productName,
      screenNumber = _a.screenNumber,
      callback = _a.callback,
      isMultisimulator = _a.isMultisimulator,
      createLeadCallback = _a.createLeadCallback,
      redirectOnbording = _a.redirectOnbording,
      cardId = _a.cardId,
      onClose = _a.onClose,
      noticeOfPrivacy = _a.noticeOfPrivacy,
      hubspotButtonsCallback = _a.hubspotButtonsCallback,
      heroLayout = _a.heroLayout,
      customProductSelector = _a.customProductSelector;

  var _b = useState(false),
      toggled = _b[0],
      setToggled = _b[1];

  var _c = useState(Products['NATURAL']),
      Prueba = _c[0],
      setPrueba = _c[1];

  var _d = useState(Products['LEGAL']),
      Prueba2 = _d[0],
      setPrueba2 = _d[1];

  var theme = useTheme();

  var _e = useState({
    simulation_id: '',
    name: '',
    phone_number: '',
    email: ''
  }),
      user = _e[0],
      setUser = _e[1];

  var productsSelected = variant === 'LEGAL' ? Products['LEGAL'] : Products['NATURAL'];
  var productSelect = productsSelected.filter(function (el) {
    return el.product === productName;
  })[0];

  var _f = useState(''),
      partnertPDF = _f[0],
      setPartnerPDF = _f[1];

  var _g = useState(false),
      checkboxEnabled = _g[0],
      setCheckboxEnabled = _g[1];

  var _h = useState(0),
      tabSelected = _h[0],
      setTabSelected = _h[1];

  var _j = useState(''),
      simulationId = _j[0],
      setSimulationId = _j[1];

  var _k = useState(''),
      thanksName = _k[0],
      setThanksName = _k[1];

  var _l = useState({}),
      payload = _l[0],
      setPayload = _l[1];

  var _m = useState(),
      endpointRes = _m[0],
      setEndpointRes = _m[1];

  var _o = useState(false),
      validations = _o[0],
      setValidations = _o[1];

  var _p = useState(screenNumber),
      screen = _p[0],
      setScreen = _p[1];

  var _q = useState(productSelect),
      product = _q[0],
      setProduct = _q[1];

  var _r = useState(true),
      enableButton = _r[0],
      setEnableButton = _r[1];

  var _s = useState([]),
      plazoMax = _s[0],
      setPlazoMax = _s[1];

  var _t = useState(''),
      plazo = _t[0],
      setPlazo = _t[1];

  var _u = useState(0),
      monto = _u[0],
      setMonto = _u[1];

  var _v = useState({
    def0: '',
    def1: '',
    def2: ''
  }),
      helper = _v[0],
      setHelper = _v[1];

  var _w = useState({
    def0: 'none',
    def1: 'none',
    def2: 'none'
  }),
      typeIntent = _w[0],
      setTypeIntent = _w[1];

  var _x = useState(false),
      loader = _x[0],
      setLoader = _x[1];

  var _y = useState({
    payload0: '',
    payload1: '',
    payload2: '',
    def0: '',
    def1: '',
    def2: ''
  }),
      data = _y[0],
      setData = _y[1];

  var _z = useState({
    def0: false,
    def1: false,
    def2: false
  }),
      customHover = _z[0],
      setCustomHover = _z[1];

  var _0 = useState(true),
      disableButton = _0[0],
      setDisableButton = _0[1];

  var _1 = useState(''),
      theCurrentDate = _1[0],
      setTheCurrentDate = _1[1];

  var _2 = useState(''),
      offerDate = _2[0],
      setOfferDate = _2[1];

  var inputsWrapper = css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    min-height: 12.5rem;\n    display: flex;\n    justify-content: space-around;\n    flex-direction: column;\n  "], ["\n    min-height: 12.5rem;\n    display: flex;\n    justify-content: space-around;\n    flex-direction: column;\n  "])));
  useEffect(function () {
    if (customProductSelector) {
      var naturalProductSelected = Prueba.filter(function (el) {
        return customProductSelector[el.name];
      });
      var LegalProductSelected = Prueba2.filter(function (el) {
        return customProductSelector[el.name];
      });
      setPrueba(naturalProductSelected);
      setPrueba2(LegalProductSelected);
    }
  }, []);
  useEffect(function () {
    var MESES = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];
    var f = new Date();
    var currentDay = f.getDate();
    var current = ' ' + currentDay + ' de ' + MESES[f.getMonth()] + ' del ' + f.getFullYear() + ' ';
    var nextDate = ' ' + new Date(f.setDate(f.getDate() + 90)).getDate() + ' de ' + MESES[f.getMonth()] + ' del ' + f.getFullYear();
    setTheCurrentDate(current);
    setOfferDate(nextDate);
  }, []);
  useEffect(function () {
    if (!isMultisimulator) {
      setScreen(1);
    }
  }, []);
  useEffect(function () {
    var cleanSimulatorValues = function cleanSimulatorValues(def) {
      var cleanValue = def.replace(/[^\d.]+/g, '');
      cleanValue = cleanValue.replace(/\.[^.]*$/, '');
      return parseInt(cleanValue);
    };

    var plazo = product === null || product === void 0 ? void 0 : product.plazoMax.map(function (term) {
      return {
        title: term.toString() + ' AÑOS',
        handleClick: function handleClick() {
          return __awaiter(void 0, void 0, void 0, function () {
            var def0, def1, def2, structure, res, awarded_amount;

            var _a;

            return __generator(this, function (_b) {
              switch (_b.label) {
                case 0:
                  if (product.type === 'OFICINAS' && !checkboxEnabled) return [2
                  /*return*/
                  ];
                  if (!(typeIntent.def0 === 'success' && typeIntent.def2 === 'success' && typeIntent.def1 === 'success')) return [3
                  /*break*/
                  , 2];
                  setLoader(true);
                  def0 = cleanSimulatorValues(data.def0);
                  def1 = cleanSimulatorValues(data.def1);
                  def2 = cleanSimulatorValues(data.def2);
                  structure = (_a = {
                    generate_id: false,
                    pdf: false,
                    person_type: product.person_type,
                    product: product.product
                  }, _a[data.payload0] = {
                    amount: def0,
                    currency: 'MXN'
                  }, _a[data.payload1] = {
                    amount: def1,
                    currency: 'MXN'
                  }, _a[data.payload2] = {
                    amount: def2,
                    currency: 'MXN'
                  }, _a.activity_years = product.activity_years, _a.term = term, _a);
                  setPayload(structure);
                  return [4
                  /*yield*/
                  , callback(product.tags, structure)];

                case 1:
                  res = _b.sent();

                  if (res === null || res === void 0 ? void 0 : res.productPartner) {
                    setPartnerPDF(res.productPartner);
                  }

                  awarded_amount = res.data.awarded_amount.amount;
                  setLoader(false);
                  setDisableButton(false);
                  setMonto('$' + awarded_amount.replace(/\B(?=(\d{3})+(?!\d))/g, ','));
                  setEndpointRes(res.data);
                  _b.label = 2;

                case 2:
                  return [2
                  /*return*/
                  ];
              }
            });
          });
        }
      };
    });
    setPlazoMax(plazo);
  }, [validations, typeIntent, product, checkboxEnabled]);
  var slideHeaderStyle = css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    min-height: ", ";\n    display: flex;\n    justify-content: ", ";\n    align-items: baseline;\n    flex-direction: row;\n    @media (max-width: 40rem) {\n      height: 2.125rem;\n      padding: 0.125rem 0 0;\n      z-index: 1;\n    }\n  "], ["\n    min-height: ", ";\n    display: flex;\n    justify-content: ", ";\n    align-items: baseline;\n    flex-direction: row;\n    @media (max-width: 40rem) {\n      height: 2.125rem;\n      padding: 0.125rem 0 0;\n      z-index: 1;\n    }\n  "])), (product === null || product === void 0 ? void 0 : product.type) === 'OFICINAS' ? '3rem' : '3.375rem', screen > 0 ? 'space-between' : 'center');

  var cleanValues = function cleanValues() {
    setData({
      payload0: '',
      payload1: '',
      payload2: '',
      def0: '',
      def1: '',
      def2: ''
    });
    setHelper({
      def0: '',
      def1: '',
      def2: ''
    });
    setTypeIntent({
      def0: 'none',
      def1: 'none',
      def2: 'none'
    });
    setMonto('0');
    setEndpointRes(undefined);
    setPayload({});
    setUser({});
  };

  var CardHeader = function CardHeader() {
    return jsx(View, {
      css: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["display:flex;\n      justify-content:center;\n      align-items:center;\n      flex-direction:row;\n      width:100%; position:relative;"], ["display:flex;\n      justify-content:center;\n      align-items:center;\n      flex-direction:row;\n      width:100%; position:relative;"])))
    }, jsx(View, {
      css: css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["", " ", ""], ["", " ", ""])), slideHeaderStyle, screen > 0 ? 'width:90%' : '')
    }, screen === 1 && isMultisimulator || screen === 2 ? jsx(View, {
      "data-testid": 'backButton',
      css: css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["transform: rotate(90deg);\n           cursor:pointer; width:1rem"], ["transform: rotate(90deg);\n           cursor:pointer; width:1rem"]))),
      onClick: function onClick() {
        setToggled(false);
        setPlazo(' ');
        var currentScreen = screen;
        setScreen(--currentScreen);
        setDisableButton(true);
        setCheckboxEnabled(false);
        cleanValues();
      }
    }, dropDown) : null, screen === 0 ? jsx(Text, {
      style: !isMultisimulator ? {
        width: '100%'
      } : {
        width: '80%'
      },
      center: true,
      variant: 'h6'
    }, "\xBFPara qu\xE9 necesitas tu cr\xE9dito?") : null, screen === 1 ? jsx(Text, {
      style: {
        width: '100%'
      },
      center: true,
      variant: 'h6'
    }, product.title) : null, screen === 2 ? jsx(Text, {
      style: {
        width: '100%'
      },
      center: true,
      variant: 'h6'
    }, "\xBFC\xF3mo te contactamos?") : null, jsx(View, {
      "data-testid": 'closeSVG',
      css: css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["transform: rotate(90deg); \n            width: 0.875rem;cursor:pointer; \n            position:absolute; right:0"], ["transform: rotate(90deg); \n            width: 0.875rem;cursor:pointer; \n            position:absolute; right:0"]))),
      onClick: function onClick() {
        if (isMultisimulator) {
          setScreen(0);
          cleanValues();
          onClose();
        } else {
          if (screen === 3) {
            onClose();
            setScreen(1);
          }

          if (screen === 0) {
            onClose();
          }
        }
      }
    }, isMultisimulator && screen <= 2 ? closeSVG : null)));
  };

  var inputValidations = function inputValidations(value, min, id, question, max) {
    var _a, _b, _c, _d, _e, _f;

    if (min >= value) {
      setTypeIntent(__assign(__assign({}, typeIntent), (_a = {}, _a[id] = 'danger', _a)));
      setHelper(__assign(__assign({}, helper), (_b = {}, _b[id] = question, _b)));
    }

    if (value >= min) {
      setTypeIntent(__assign(__assign({}, typeIntent), (_c = {}, _c[id] = 'success', _c)));
      setHelper(__assign(__assign({}, helper), (_d = {}, _d[id] = '', _d)));
    }

    if (product.person_type === 'NATURAL') {
      if (value > max) {
        setTypeIntent(__assign(__assign({}, typeIntent), (_e = {}, _e[id] = 'danger', _e)));
        setHelper(__assign(__assign({}, helper), (_f = {}, _f[id] = 'Monto a requerir superado', _f)));
      }
    }

    if (typeIntent.def0 === 'success' && typeIntent.def1 === 'success' && typeIntent.def2 === 'success') {
      if (product.type !== 'OFICINAS') {
        setValidations(false);
        setValidations(true);
      } else {
        if (checkboxEnabled) {
          setValidations(false);
          setValidations(true);
        }
      }
    } else {
      setValidations(false);
    }
  };

  var _onChange = function onChange(e, min, question, endpointField, max) {
    var _a, _b, _c, _d, _e;

    var id = e.target.id;
    var cleanValue = e.target.value.toString();
    var sanitizeValue = e.target.value.replace(/[^\d.]+/g, '');
    sanitizeValue = sanitizeValue.replace(/\.[^.]*$/, '');
    inputValidations(sanitizeValue, min, id, question, max);

    if (id === 'def0') {
      setData(__assign(__assign({}, data), (_a = {
        payload0: endpointField
      }, _a[id] = cleanValue, _a)));
    }

    if (id === 'def1') {
      setData(__assign(__assign({}, data), (_b = {
        payload1: endpointField
      }, _b[id] = cleanValue, _b)));
    }

    if (id === 'def2') {
      setData(__assign(__assign({}, data), (_c = {
        payload2: endpointField
      }, _c[id] = cleanValue, _c)));
    }

    if (cleanValue < 9) {
      setCustomHover(__assign(__assign({}, customHover), (_d = {}, _d[e.target.id] = true, _d)));
    } else {
      setCustomHover(__assign(__assign({}, customHover), (_e = {}, _e[e.target.id] = false, _e)));
    }
  };

  var HeroOferta = function HeroOferta() {
    return jsx(View, {
      css: css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["display:flex;\n      flex-direction:column;\n      justify-content:center;\n      margin-top:1rem;\n      align-items:center;"], ["display:flex;\n      flex-direction:column;\n      justify-content:center;\n      margin-top:1rem;\n      align-items:center;"])))
    }, jsx(View, {
      css: css(templateObject_9 || (templateObject_9 = __makeTemplateObject(["display:flex;\n        flex-direction:row;\n        justify-content:space-around;\n        width:100%;\n        border-radius: 0.5rem;\n        width: 99%;\n        padding-top: 1rem;\n        padding-bottom: 1rem;"], ["display:flex;\n        flex-direction:row;\n        justify-content:space-around;\n        width:100%;\n        border-radius: 0.5rem;\n        width: 99%;\n        padding-top: 1rem;\n        padding-bottom: 1rem;"])))
    }, jsx(View, {
      style: {
        paddingRight: '1.25rem',
        borderRight: "0.063rem solid ".concat(theme.colors.scales.grayShades[2])
      }
    }, jsx(Texts, {
      variant: 'caption',
      size: 'medium',
      center: true
    }, "Te podr\xEDamos prestar hasta"), jsx(Texts, {
      muted: true,
      style: {
        textAlign: 'center'
      },
      css: css(templateObject_10 || (templateObject_10 = __makeTemplateObject(["color:", ""], ["color:", ""])), theme.colors.scales.green[7]),
      variant: 'paragraph',
      size: 'medium',
      weight: 'bold'
    }, monto, " MXN")), jsx(View, {
      css: extraContainerStyleHero
    }, jsx(Texts, {
      variant: 'caption',
      size: 'medium'
    }, "Pago mensual "), jsx(View, {
      css: css(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n              align-items: flex-end;\n              display: flex;\n              flex-direction: column;\n            "], ["\n              align-items: flex-end;\n              display: flex;\n              flex-direction: column;\n            "])))
    }, jsx(Texts, {
      css: css(templateObject_12 || (templateObject_12 = __makeTemplateObject(["color:", ""], ["color:", ""])), theme.colors.scales.green[7]),
      variant: 'paragraph',
      size: 'medium',
      weight: 'bold'
    }, "$", (endpointRes === null || endpointRes === void 0 ? void 0 : endpointRes.monthly_payment.amount.replace(/\B(?=(\d{3})+(?!\d))/g, ',')) || 0, " MXN")))), endpointRes ? jsx(Button, {
      "data-testid": 'pdfButton',
      variant: 'ghost',
      disabled: disableButton && endpointRes === undefined,
      css: css(templateObject_13 || (templateObject_13 = __makeTemplateObject(["width:100%"], ["width:100%"]))),
      onClick: function onClick() {
        return __awaiter(void 0, void 0, void 0, function () {
          var response, taxInvoiceUrl;
          return __generator(this, function (_a) {
            switch (_a.label) {
              case 0:
                if (payload) {
                  payload.generate_id = false;
                  payload.pdf = true;
                }

                if (partnertPDF.length > 1) {
                  payload.product = partnertPDF + payload.product;
                }

                setLoader(true);
                return [4
                /*yield*/
                , callback(product.tags, payload)];

              case 1:
                response = _a.sent();
                taxInvoiceUrl = window.URL.createObjectURL(new Blob([base64js.toByteArray(response.data.amortization_table.file.data)], {
                  type: 'application/pdf'
                }));
                setLoader(false);
                setTimeout(function () {
                  var link = document.createElement('a');
                  link.href = taxInvoiceUrl;
                  link.download = 'Tabla_de_amortización.pdf';
                  link.dispatchEvent(new MouseEvent('click'));
                }, 800);
                return [2
                /*return*/
                ];
            }
          });
        });
      }
    }, jsx(Texts, {
      muted: true,
      css: css(templateObject_14 || (templateObject_14 = __makeTemplateObject(["\n              color:", ";\n            "], ["\n              color:", ";\n            "])), theme.colors.scales.blue[5]),
      variant: 'label',
      size: 'small',
      weight: 'bold'
    }, "VER TABLA DE AMORTIZACI\xD3N")) : null, jsx(Button, {
      "data-testid": 'oferta',
      style: {
        marginTop: 16,
        width: '100%',
        marginBottom: '1rem'
      },
      disabled: disableButton && endpointRes === undefined,
      variant: 'default',
      size: 'md',
      onClick: function onClick() {
        return __awaiter(void 0, void 0, void 0, function () {
          var res;
          return __generator(this, function (_a) {
            switch (_a.label) {
              case 0:
                setToggled(false);
                setPlazo(' ');
                setLoader(true);

                if (payload) {
                  payload.generate_id = true;
                  payload.pdf = false;
                }

                return [4
                /*yield*/
                , callback(product.tags, payload)];

              case 1:
                res = _a.sent();
                setLoader(false);

                if (res.data.id) {
                  setSimulationId(res.data.id);
                  setScreen(2);

                  if (hubspotButtonsCallback) {
                    hubspotButtonsCallback(isMultisimulator ? 'Multi_' + product.type : 'Single_' + product.type);
                  }
                }

                return [2
                /*return*/
                ];
            }
          });
        });
      }
    }, jsx(Texts, {
      size: 'medium',
      weight: 'bold',
      variant: 'button'
    }, "QUIERO UNA OFERTA PERSONALIZADA")), (endpointRes === null || endpointRes === void 0 ? void 0 : endpointRes.monthly_payment.amount) ? jsx(Texts, {
      muted: true,
      variant: 'label',
      size: 'small',
      weight: 'regular',
      style: {
        textAlign: 'justify',
        textTransform: 'none',
        color: theme.colors.scales.grayShades[4],
        marginBottom: '2rem'
      }
    }, "CAT ", endpointRes === null || endpointRes === void 0 ? void 0 : endpointRes.cat, "% sin IVA, Tasa ", endpointRes === null || endpointRes === void 0 ? void 0 : endpointRes.interest_rate, "%, para fines informativos y de comparaci\xF3n. Fecha de c\xE1lculo", theCurrentDate, ". Vigencia de la oferta hasta el", offerDate, ", Este es un  ejercicio num\xE9rico de acuerdo a una simulaci\xF3n de condiciones financieras del cr\xE9dito solicitado. Es tu derecho solicitar la oferta vinculante para comparar distintas opciones de cr\xE9dito, Consulta los T\xE9rminos y Condiciones de contrataci\xF3n, comisiones aplicables y requisitos") : jsx(View, {
      css: css(templateObject_15 || (templateObject_15 = __makeTemplateObject(["min-height:4.375rem;"], ["min-height:4.375rem;"])))
    }));
  };

  var tabs = [{
    title: 'PERSONAS',
    content: jsx(View, {
      id: 'personasProducts',
      css: css(templateObject_16 || (templateObject_16 = __makeTemplateObject(["height:26.875rem;"], ["height:26.875rem;"])))
    }, Prueba.map(function (el, index) {
      return jsx(SimulatorCards, {
        callback: function callback() {
          setProduct(el);
          setEnableButton(false);
          Prueba.map(function (el, i) {
            if (index !== i) {
              el.checkbox = false;
            } else if (index === i) {
              el.checkbox = true;
            }
          });
          setPrueba(Prueba);

          if (hubspotButtonsCallback) {
            hubspotButtonsCallback(el.type);
          }

          setScreen(1);
        },
        icon: el.icon,
        checked: el.checkbox,
        title: el.title,
        description: el.description,
        key: index
      });
    })),
    handleClick: function handleClick() {
      Prueba.map(function (el) {
        el.checkbox = false;
      });
      setEnableButton(true);
      setPrueba(Prueba);
      setTabSelected(0);
    }
  }, {
    title: 'EMPRESAS',
    content: jsx(View, {
      id: 'empresasProducts',
      css: css(templateObject_17 || (templateObject_17 = __makeTemplateObject(["height:26.875rem;"], ["height:26.875rem;"])))
    }, Prueba2.map(function (el, index) {
      return jsx(SimulatorCards, {
        callback: function callback() {
          setTabSelected(1);
          setProduct(el);
          setEnableButton(false);
          Prueba2.map(function (el, i) {
            if (index !== i) {
              el.checkbox = false;
            } else if (index === i) {
              el.checkbox = true;
            }
          });
          setPrueba2(Prueba2);

          if (hubspotButtonsCallback) {
            hubspotButtonsCallback(el.type);
          }

          setScreen(1);
        },
        icon: el.icon,
        checked: el.checkbox,
        title: el.title,
        description: el.description,
        key: index
      });
    })),
    handleClick: function handleClick() {
      Prueba2.map(function (el) {
        el.checkbox = false;
      });
      setEnableButton(true);
      setPrueba(Prueba);
      setTabSelected(0);
      setTabSelected(1);
    }
  }];
  return jsx(Wrapper, {
    isMultisimulator: isMultisimulator,
    heroLayout: heroLayout,
    cardId: cardId
  }, jsx(CardHeader, null), screen === 0 ? jsx(Texts, {
    center: true,
    variant: 'paragraph',
    size: 'medium'
  }, "Selecciona una opci\xF3n para continuar") : null, screen === 1 ? jsx(Texts, {
    center: true,
    variant: 'paragraph',
    size: 'medium'
  }, "Simula tu cr\xE9dito, completa el formulario") : null, screen === 2 ? jsx(Texts, {
    center: true,
    variant: 'paragraph',
    size: 'medium'
  }, "Ingresa tu informaci\xF3n para poder dar seguimiento a tu oferta") : null, loader ? jsx(Loader, {
    loaderZIndex: 1
  }) : null, jsx(SwipeableViews, {
    disabled: true,
    springConfig: {
      duration: '5s',
      delay: '5s',
      easeFunction: 'easeInSine'
    },
    style: {
      overflowX: 'hidden'
    },
    index: screen,
    css: swipeableContainerStyle
  }, screen > 0 ? jsx(View, null) : jsx(View, null, jsx(View, null, jsx(Tabs, {
    isMobile: true,
    initialTab: tabSelected,
    tabs: tabs,
    variant: 'default',
    render: function render(content) {
      return content;
    }
  }))), screen === 0 || screen === 2 || screen === 3 ? jsx(View, null) : jsx(View, null, jsx(View, {
    css: questionsWrapper
  }, (product === null || product === void 0 ? void 0 : product.type) === 'OFICINAS' ? jsx(View, {
    style: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center'
    }
  }, jsx(View, null, jsx(Texts, {
    variant: 'paragraph',
    size: 'small',
    weight: 'regular'
  }, "Confirmo que soy PFAE ", jsx(Tooltip, {
    content: "Registro ante el SAT como Persona F\xEDsica con Actividad Empresarial"
  }, infoSVG))), jsx(View, {
    "data-testid": 'toggle_offices'
  }, jsx(Toggle, {
    size: 'md',
    ischecked: toggled,
    labelChecked: '',
    labelUnChecked: '',
    onToggleChange: function onToggleChange(e) {
      setToggled(e.target.checked);
      setCheckboxEnabled(!checkboxEnabled);

      if (toggled) {
        setDisableButton(true);
        setEndpointRes(undefined);
        setMonto('0');
      }
    }
  }))) : null, jsx(View, {
    css: inputsWrapper
  }, jsx(Tooltip, {
    customHover: customHover.def0,
    content: product.tooltips[0]
  }, jsx(InputText, {
    disabled: product.type === 'OFICINAS' ? !checkboxEnabled : false,
    type: 'currency',
    label: product.questions[0].question,
    caption: 'MXN',
    id: 'def0',
    style: {
      fontFamily: 'Grotta'
    },
    onChange: function onChange(e) {
      _onChange(e, product.questions[0].min, product.questions[0].helper, product.questions[0].endpoint_field, product.questions[0].max);
    },
    value: data.def0,
    autoFocusIndex: 0,
    autoFocusDelay: 600,
    focusOnDisplay: false,
    onBlur: function onBlur() {
      setCustomHover(__assign(__assign({}, customHover), {
        def0: false
      }));
    },
    onFocus: function onFocus() {
      setCustomHover(__assign(__assign({}, customHover), {
        def0: true
      }));
    },
    inputMode: 'numeric',
    autoComplete: 'off',
    helper: helper.def0,
    variant: 'currency',
    intent: typeIntent.def0,
    setEraseValue: function setEraseValue() {
      setData(__assign(__assign({}, data), {
        def0: ''
      }));
      setTypeIntent(__assign(__assign({}, typeIntent), {
        def0: 'none'
      }));
      setHelper(__assign(__assign({}, helper), {
        'def0': ''
      }));
    }
  })), jsx(Tooltip, {
    customHover: customHover.def1,
    content: product.tooltips[1]
  }, jsx(InputText, {
    disabled: product.type === 'OFICINAS' ? !checkboxEnabled : false,
    style: {
      fontFamily: 'Grotta'
    },
    type: 'currency',
    label: product.questions[1].question,
    caption: 'MXN',
    id: 'def1',
    onChange: function onChange(e) {
      _onChange(e, product.questions[1].min, product.questions[1].helper, product.questions[1].endpoint_field, product.questions[1].max);
    },
    value: data.def1,
    autoFocusIndex: 0,
    autoFocusDelay: 600,
    focusOnDisplay: false,
    onBlur: function onBlur() {
      setCustomHover(__assign(__assign({}, customHover), {
        def1: false
      }));
    },
    onFocus: function onFocus() {
      setCustomHover(__assign(__assign({}, customHover), {
        def1: true
      }));
    },
    pattern: '[0-9]*',
    inputMode: 'numeric',
    autoComplete: 'off',
    helper: helper.def1,
    variant: 'currency',
    intent: typeIntent.def1,
    setEraseValue: function setEraseValue() {
      setData(__assign(__assign({}, data), {
        def1: ''
      }));
      setTypeIntent(__assign(__assign({}, typeIntent), {
        def1: 'none'
      }));
      setHelper(__assign(__assign({}, helper), {
        'def1': ''
      }));
    }
  })), jsx(Tooltip, {
    customHover: customHover.def2,
    content: product.tooltips[2]
  }, jsx(InputText, {
    disabled: product.type === 'OFICINAS' ? !checkboxEnabled : false,
    style: {
      fontFamily: 'Grotta'
    },
    type: 'currency',
    label: product.questions[2].question,
    caption: 'MXN',
    id: 'def2',
    onChange: function onChange(e) {
      _onChange(e, product.questions[2].min, product.questions[2].helper, product.questions[2].endpoint_field, product.questions[2].max);
    },
    value: data.def2,
    autoFocusIndex: 0,
    autoFocusDelay: 600,
    focusOnDisplay: false,
    onBlur: function onBlur() {
      setCustomHover(__assign(__assign({}, customHover), {
        def2: false
      }));
    },
    onFocus: function onFocus() {
      setCustomHover(__assign(__assign({}, customHover), {
        def2: true
      }));
    },
    pattern: '[0-9]*',
    inputMode: 'numeric',
    autoComplete: 'off',
    helper: helper.def2,
    variant: 'currency',
    intent: typeIntent.def2,
    setEraseValue: function setEraseValue() {
      setData(__assign(__assign({}, data), {
        def2: ''
      }));
      setTypeIntent(__assign(__assign({}, typeIntent), {
        def2: 'none'
      }));
      setHelper(__assign(__assign({}, helper), {
        'def2': ''
      }));
    }
  })))), jsx(View, {
    css: css(templateObject_18 || (templateObject_18 = __makeTemplateObject(["margin-top:1rem"], ["margin-top:1rem"])))
  }, jsx(InputText, {
    id: 'yearSelector',
    "data-testid": 'yearSelector',
    variant: 'select',
    label: "Selecciona el plazo de tu cr\xE9dito",
    intent: 'none',
    value: plazo,
    style: {
      fontFamily: 'Grotta'
    },
    autoFocusIndex: 0,
    autoFocusDelay: 600,
    focusOnDisplay: false,
    onSelectItem: function onSelectItem(title) {
      return __awaiter(void 0, void 0, void 0, function () {
        var cleanSimulatorValues, def0, def1, def2, structure, res, awarded_amount;

        var _a;

        return __generator(this, function (_b) {
          switch (_b.label) {
            case 0:
              setPlazo(title);

              cleanSimulatorValues = function cleanSimulatorValues(def) {
                var cleanValue = def.replace(/[^\d.]+/g, '');
                cleanValue = cleanValue.replace(/\.[^.]*$/, '');
                return parseInt(cleanValue);
              };

              if (product.type === 'OFICINAS' && !checkboxEnabled) return [2
              /*return*/
              ];
              if (!(typeIntent.def0 === 'success' && typeIntent.def2 === 'success' && typeIntent.def1 === 'success')) return [3
              /*break*/
              , 2];
              setLoader(true);
              def0 = cleanSimulatorValues(data.def0);
              def1 = cleanSimulatorValues(data.def1);
              def2 = cleanSimulatorValues(data.def2);
              structure = (_a = {
                generate_id: false,
                pdf: false,
                person_type: product.person_type,
                product: product.product
              }, _a[data.payload0] = {
                amount: def0,
                currency: 'MXN'
              }, _a[data.payload1] = {
                amount: def1,
                currency: 'MXN'
              }, _a[data.payload2] = {
                amount: def2,
                currency: 'MXN'
              }, _a.activity_years = product.activity_years, _a.term = parseInt(title.split(' ')[0]), _a);
              setPayload(structure);
              return [4
              /*yield*/
              , callback(product.tags, structure)];

            case 1:
              res = _b.sent();

              if (res === null || res === void 0 ? void 0 : res.productPartner) {
                setPartnerPDF(res.productPartner);
              }

              awarded_amount = res.data.awarded_amount.amount;
              setLoader(false);
              setDisableButton(false);
              setMonto('$' + awarded_amount.replace(/\B(?=(\d{3})+(?!\d))/g, ','));

              if (res) {
                setEndpointRes(res === null || res === void 0 ? void 0 : res.data);
              }

              _b.label = 2;

            case 2:
              return [2
              /*return*/
              ];
          }
        });
      });
    },
    initItems: plazoMax
  })), jsx(View, null, jsx(HeroOferta, null))), jsx(View, {
    style: {
      height: '100%'
    }
  }, screen !== 2 ? jsx(View, null) : jsx(ContactView, {
    heroLayout: heroLayout,
    isMultisimulator: isMultisimulator,
    productType: product.type,
    hubspotButtonsCallback: hubspotButtonsCallback,
    noticeOfPrivacy: noticeOfPrivacy,
    monto: monto,
    setUser: setUser,
    simulationID: simulationId,
    setThanksName: setThanksName,
    setLoader: setLoader,
    createLeadCallback: createLeadCallback,
    setScreen: setScreen
  })), jsx(View, null, jsx(LeadView, {
    heroLayout: heroLayout,
    onClose: onClose,
    cleanValues: cleanValues,
    isMultisimulator: isMultisimulator,
    user: user,
    redirectOnbording: redirectOnbording,
    thanksName: thanksName,
    setScreen: setScreen
  }))));
};

var questionsWrapper = css(templateObject_19 || (templateObject_19 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  justify-content: space-around;\n"], ["\n  display: flex;\n  flex-direction: column;\n  justify-content: space-around;\n"])));
var swipeableContainerStyle = css(templateObject_20 || (templateObject_20 = __makeTemplateObject(["\n  width:100%;\n"], ["\n  width:100%;\n"])));
var extraContainerStyle = css(templateObject_21 || (templateObject_21 = __makeTemplateObject(["\n  display: flex;\n  width: 100%;\n  justify-content: space-between;\n  align-items: center;\n  @media (max-width: 40rem) {\n    margin: 0 0 0.938rem;\n  }\n"], ["\n  display: flex;\n  width: 100%;\n  justify-content: space-between;\n  align-items: center;\n  @media (max-width: 40rem) {\n    margin: 0 0 0.938rem;\n  }\n"])));
var extraContainerStyleHero = css(templateObject_22 || (templateObject_22 = __makeTemplateObject(["\n  display: flex;\n  flex-direction:column;\n  justify-content: space-between;\n  align-items: center;\n  @media (max-width: 40rem) {\n    margin: 0 0 0.938rem;\n  }\n"], ["\n  display: flex;\n  flex-direction:column;\n  justify-content: space-between;\n  align-items: center;\n  @media (max-width: 40rem) {\n    margin: 0 0 0.938rem;\n  }\n"])));
export { Simulator };
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19, templateObject_20, templateObject_21, templateObject_22;